import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO } from "@/lib/constants";

const links = [
  { label: "L’esperienza", href: "#about" },
  { label: "Galleria", href: "#gallery" },
  { label: "Musica", href: "#musica" },
  { label: "Trailer", href: "#trailer" },
  { label: "Eventi", href: "#events" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 px-4 sm:px-6 lg:px-8 pt-4"
    >
      <div
        className={`mx-auto flex max-w-7xl items-center justify-between rounded-full px-4 sm:px-5 transition-all duration-500 ${
          scrolled ? "py-2 glass" : "py-2.5"
        }`}
      >
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5"
        >
          <img src={LOGO} alt="Cosplay Singers" className="h-10 w-10 object-contain" />
          <span className="font-serif text-base sm:text-lg tracking-tightest text-navy">Cosplay Singers</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              onClick={() => go(l.href)}
              className="text-sm text-navy-soft hover:text-lavender-deep transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/community"
            data-testid="nav-community"
            className="text-sm font-medium text-lavender-deep hover:text-lavender transition-colors duration-300"
          >
            Community
          </Link>
        </nav>

        <button
          data-testid="nav-booking-btn"
          onClick={() => go("#booking")}
          className="hidden md:inline-flex items-center rounded-full bg-lavender px-5 py-2.5 text-sm font-medium text-white hover:bg-lavender-deep transition-colors duration-300 glow-lav"
        >
          Richiedi lo spettacolo
        </button>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-navy text-sm rounded-full border border-navy/15 px-4 py-2"
        >
          {open ? "Chiudi" : "Menu"}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden mt-3 overflow-hidden rounded-3xl glass-strong"
          >
            <div className="flex flex-col px-6 py-5 gap-4">
              {links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`nav-mobile-${l.href.replace("#", "")}`}
                  onClick={() => go(l.href)}
                  className="text-left text-base text-navy/80"
                >
                  {l.label}
                </button>
              ))}
              <Link
                to="/community"
                data-testid="nav-mobile-community"
                onClick={() => setOpen(false)}
                className="text-left text-base font-medium text-lavender-deep"
              >
                Community
              </Link>
              <button
                data-testid="nav-mobile-booking-btn"
                onClick={() => go("#booking")}
                className="mt-2 rounded-full bg-lavender px-5 py-3 text-sm font-medium text-white"
              >
                Richiedi lo spettacolo
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
